module.exports = __webpack_public_path__ + "static/media/prop-5@2x.4dfe84ba.webp";